// extracted by mini-css-extract-plugin
export default {"loadingIconBox":"loadingIcon_loadingIconBox__YSFlZ","loadindIconContent":"loadingIcon_loadindIconContent__GssYa","loading":"loadingIcon_loading__mMbcg"};